export default __webpack_public_path__ + "static/media/undraw_Mobile_wireframe_re_jxui.a51e4264.png";